<template>
  <div class="IGOSwitch" :data-selected="$store.state.activeIgo != null">
    <button
      v-on:click="toggleIGOList"
      :data-selected="$store.state.activeIgo != null"
      :data-active="active"
      >
      <img :src="require('@/assets/icons/government.svg')"  alt="">
      <div style="display:flex;flex-flow:column nowrap;">
        <span class="hide-sm" style="text-align: left;">{{ $store.state.activeIgo ? this.$igoPlaces[this.$store.state.activeIgo]['igoshortname'+this.lang] : words[this.lang].igo.WorldView  }}</span>
        <span class="show-sm" style="text-align: left;">{{ $store.state.activeIgo ? this.$igoPlaces[this.$store.state.activeIgo]['igoshortname'+this.lang] : words[this.lang].igo.ButtonSmall  }}</span>
        <span class="hide-sm" style="font-size: 0.7em;max-width: 9rem;text-align: left; color:#555;">{{ $store.state.activeIgo ? this.$igoPlaces[this.$store.state.activeIgo]['igoname'+this.lang] : words[this.lang].igo.ButtonLarge }}</span>
      </div>
      <img v-on:click="updateActiveIGO($store.state.activeIgo, true)" class="close" :src="require('@/assets/icons/close.svg')"  alt="">
      <img class="dropdown" :src="require('@/assets/icons/arrow_drop_down.svg')"  alt="">
    </button>
    <ul :class="'IGOSwitch__list ' + (active ? 'IGOSwitch__list--show' : '')">
      <li
        v-for="(igo, index) in this.$igoPlaces"
        v-show="igo.places !== undefined"
        :key="index"
        :data-name="igo['igoname'+$store.state.language.lang]"
        :data-active="$store.state.activeIgo == index"
        v-on:click="updateActiveIGO(igo['igoshortnameen'])">
          {{ igo['igoshortname'+$store.state.language.lang] }}
        </li>
    </ul>
  </div>
</template>

<script>
import { words } from '@/constants/lang'

export default {
  name: 'IGOSwitch',
  data: function() {
    return {
      words,
      active: this.$store.state.mobile ? false : (this.$store.state.activeCountry === null),
    }
  },
  methods: {
    toggleIGOList() {
      this.active = !this.active
    },
    updateActiveIGO(igoId, toggle = true) {
      this.$store.commit('updateActiveIGO', igoId)
      if (toggle) this.toggleIGOList()
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    },
    igoIsSelected: function () {
      return this.$store.state.activeIgo != null
    },
    igoPlaces: function () {
      let igo = this.$igoPlaces;

      return Object.keys(igo)
        .filter(function (key) {
          igo[key].places !== undefined
        })
    }
  }
}
</script>

<style lang="less">

  @import "../less/_var.less";

  .IGOSwitch {
    display: flex;
    flex-flow: column nowrap;
    width: fit-content;
    position: absolute;
    top: 15px;
    left: 15px;
    margin: 0 auto;
    pointer-events: none;

    button {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background: rgba(255,255,255);
      box-shadow: 0 3px 14px -3px rgba(0, 0, 0, 0.15);
      transition: all .1s ease-out;
      padding: 11px 12px 9px 8px;
      border-radius: 3px;
      outline: none;
      border: none;
      cursor: pointer;
      pointer-events: initial;
      font-family: 'Campton', sans-serif;
      font-weight: 400;
      font-size: 0.8em;
      border-right: solid 2px #666;

      span {

      }

      img {
        @height: 18px;
        max-height: @height;
        height: @height;
        max-width: 20px;
        margin-right: 8px;
        margin-bottom: 2px;

        &:first-child {
          margin-left: 4px;
        }

        &.close {
          margin-right: 0;
          width: 0;
          transform: scale(0) translateX(5px);
          transition: transform 0.2s cubic-bezier(.84,1.79,1,1);
        }
        &.dropdown {
          margin-right: 0;
          margin-left: 8px;

          transform: rotate(180deg);
          transition: transform 0.2s cubic-bezier(.84,1.79,1,1);
        }
      }

      &[data-active="true"] {
        background: rgba(255,255,255,0.8);
        img.dropdown {
          transform: rotate(0deg);
        }
      }
      &[data-selected="true"] {
        img.close {
          width: inherit;
          transform: scale(1) translateX(5px);
        }
      }
    }


    .IGOSwitch__list {
      display: flex;
      flex-flow: column nowrap;
      list-style: none;
      padding: 0;
      margin: 10px 0;
      margin: 0;
      box-shadow: none;
      border-radius: 2px;
      pointer-events: none;

      li {
        color: #444;
        position: relative;
        font-size: 0.8em;
        margin: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        background: rgba(255,255,255,.8);
        cursor: pointer;
        transition: all 150ms ease-in;
        opacity: 0;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 0;
        padding: 8px;
        border-radius: 0;

        @rad: 6px;

        &:first-child {
          border-radius: @rad @rad 0 0;
          margin-top: 3px;
        }

        &:last-child {
          border-radius: 0 0 @rad @rad;
        }


        &:hover {
          background-color: rgba(220,220,220,.8);

          &::after {
            opacity: 1;
            transform: scale(1);
          }
        }

        &[data-active="true"] {
          background: rgba(14, 11, 11, 0.8);
          color: white;
          font-weight: bold;
        }

        &::after {
          content: attr(data-name);
          opacity: 0;
          transition: all 150ms ease-in;
          position: absolute;
          left: calc(100% + 15px);
          transform: scale(0);
          transform-origin: left center;
          display: flex;
          align-items: center;
          padding: 5px 8px 3px 8px;
          border-radius: 5px;
          font-weight: 100;
          color: white;
          background: rgba(14, 11, 11, 0.8);
          box-shadow: 0 2px 10px -3px rgba(0, 0, 0, 0.15);
          width: max-content;
        }
      }

      &--show {
        display: flex;
        box-shadow: 0 2px 10px -3px rgba(0, 0, 0, 0.15);
        pointer-events: initial;

        li {
          opacity: 1;
          pointer-events: initial;
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    .IGOSwitch__list {
      overflow-y: auto;
      max-height: calc(100vh - 294px);

      li::after {
        content: none !important;
      }
    }
  }

</style>
